<template>
  <v-container fluid>
    <v-alert type="error">
      <template v-if="errorCode === 'google'">
        Google email accounts are not supported at this time.
      </template>
      <template v-else-if="errorCode === 'disabled'">
        That integration is not enabled for your team. Please contact Mobile Locker support.
      </template>
      <template v-else>
        Something went wrong. Please contact Mobile Locker support.
      </template>
    </v-alert>
  </v-container>
</template>
<script>
export default {
  computed: {
    errorMessage() {

    },
    errorCode() {
      return this.$route.query.code;
    }
  }
}
</script>
